import { useParams } from 'react-router-dom';
import { useQuery, useMutation, useQueryClient, QueryClient, QueryClientProvider } from '@tanstack/react-query';

import Player from './Player';
import { api } from '../../AppConfig';

function RoutedPlayer() {
  // Access the client
  const queryClient = useQueryClient();

  // Access the path params
  const { id } = useParams();
  // console.warn('che id mi viene passato?', id);

  //otherwise we fetch the data and pass to the display component
  const playerQuery = useQuery({ 
    queryKey: ['player'], 
    queryFn: () => 
      fetch(api.players().detailsById(id).href).then((res) =>
        res.json(), 
      )
  })

  if (!id) return (<div></div>);

  return <Player id={id} player={playerQuery} />;
}

export default RoutedPlayer;